<ng-container *transloco="let _t">

<div class="header-suppl row" *ngIf="openedObjectif==null">
 	<h5 class="col-3 text-end">{{ _t('rm-main-h5-0') }} </h5>
	<mat-chip-list class="col-7">
		<mat-chip *ngFor="let slice of sliceFilter"
			color="disabled"
			[ngStyle]="{'background-color': slice.show ? slice.color : '#a6a6a6'}"
			[matBadge]="slice.count" matBadgePosition="after" matBadgeColor="primary"
			[title]="slice.count+' indicateurs '+slice.label+'. Cliquez pour '
			+(slice.show ? 'les masquer' : 'les montrer')" 
			(click)="slice.show = !slice.show; calcInit()">
			{{ _t(slice.label) }}
		</mat-chip>
	</mat-chip-list>
</div>

<rm-objectif #objSheet 
	*ngIf="openedObjectif!=null"
	[objectif]="openedObjectif"
	(closeTriggered)="openedObjectif=null">
</rm-objectif>

<div class="left-aligned row">

	<div class="col-3 navigation frame" *ngIf="showSummary">

		<ul class="infos">
			<li>{{ _t('rm-audit-generator-li-date') }} :
				<strong>{{diagnostic.date}}</strong>
			</li>
			<li>{{ _t('rm-audit-generator-li-0')}} : 
				<strong>{{nbIndicators}}</strong>
			</li>
			<li>{{ _t('rm-audit-generator-li-1')}} : 
				<strong>{{objectifsList.length}}</strong>
			</li>
			<li>{{ _t('rm-audit-generator-li-2')}} :
				  <strong>{{totalBudgets}} €</strong>
			</li>
		</ul>

		<p>&nbsp;</p>
		<h3 class="darkbg text-center">{{ _t('rm-audit-generator-h2-0') }}</h3>

		<div *ngFor="let chapter of chapters; let chI=index">
			<h3 *ngIf="chapter.indiGroups.length>0">
				Chapitre {{chI+1}} : {{chapter.name}}
			</h3>
			<ol class="indiGroups">
			 <li *ngFor="let indiGroup of chapter.indiGroups">
				<h4 class="indiGroup">{{indiGroup.name}}</h4>
				<ul class="indicators">
				  <li *ngFor="let indicator of getIndicatorList(indiGroup)">
					<mat-icon *ngIf="indicator.answer.objectif!=null"
					class="objectif-puce" >
		  				account_tree</mat-icon>
		  				
					<mat-icon
					[ngStyle]="{'color': indicator.answer.slice.color}" class="puce" >
		  				radio_button_checked</mat-icon>
					<span (click)="openIndicator(indicator)"
						[ngClass]="{'selected': openedIndicator!=null && openedIndicator.id==indicator.id}">
					{{indicator.name}}</span>


				  </li>
				</ul>
			  </li>
			</ol>
		</div>
	</div>
	<div class="col-9 indicateur">
		<rm-indicator *ngIf="openedIndicator!=null"
			#indicator
			[indicator]="openedIndicator"
			[diagnostic]="diagnostic"
			[objectif]="openedIndicator.answer.objectif"
			(onOpenObjectif)="displayObjectif(openedIndicator.answer.objectif)">
		</rm-indicator> 
	</div>

</div><!-- left-aligned-->

</ng-container>